<template>
	<div class="bg-white rounded-lg shadow-sm border border-border p-6 w-full">
		<!-- Header -->
		<div class="flex items-start justify-between mb-4">
			<div>
				<h3 class="text-lg font-semibold text-text-primary">
					{{ claim.type }}
				</h3>
				<p class="text-sm text-text-secondary mt-1">
					Claim #{{ claim.id }}
				</p>
			</div>
			<span
				class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
				:class="getStatusClass(claim.status)"
			>
				{{ claim.status }}
			</span>
		</div>

		<div class="space-y-3 mb-6">
			<div class="flex justify-between items-center">
				<span class="text-sm text-text-secondary">Filed Date</span>
				<span class="text-sm font-medium text-text-primary">{{
					claim.date
				}}</span>
			</div>
			<div class="flex justify-between items-center">
				<span class="text-sm text-text-secondary">Claim Amount</span>
				<span class="text-sm font-medium text-text-primary">{{
					formatCurrency(claim.amount)
				}}</span>
			</div>
		</div>

		<button
			@click="handleViewClaim"
			class="w-full bg-primary hover:bg-primary-light text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200"
		>
			View Claim
		</button>
	</div>
</template>

<script>
export default {
	name: 'ClaimCard',
	props: {
		claim: {
			type: Object,
			required: true,
			validator: (claim) => {
				return (
					claim.id &&
					claim.type &&
					claim.date &&
					claim.status &&
					claim.amount !== undefined
				);
			},
		},
	},
	methods: {
		handleViewClaim() {
			this.$emit('view-claim', this.claim);
		},
		formatCurrency(amount) {
			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'KSH',
			}).format(amount);
		},
		getStatusClass(status) {
			const statusMap = {
				'In Review': 'bg-amber-50 text-amber-700',
				Approved: 'bg-emerald-50 text-emerald-700',
				Rejected: 'bg-red-50 text-red-700',
				Pending: 'bg-blue-50 text-blue-700',
				Completed: 'bg-emerald-50 text-emerald-700',
			};
			return statusMap[status] || 'bg-gray-50 text-gray-700';
		},
	},
};
</script>
